// Dummy class necessary to give `babel-transform-custom-element-classes`
// something to operate on, producing es5-compatible code.
export class _HTMLElement extends HTMLElement {}
